import React, { useState } from 'react';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';
import { useFormalGameDispatch, useFormalGameState } from './useFormalGame';
import Button from '~~elements/Button';

export const columns = [
  {
    column: 'PASeq',
    label: '流水號',
    className: 'first',
  },
  {
    column: 'side',
    label: '進攻方',
  },
  {
    column: 'inning',
    label: '局數',
  },
  {
    column: 'is_scoring',
    label: '有得分',
  },
  {
    column: 'has_substitution',
    label: '有換人',
  },
  {
    column: 'video_started_at',
    label: '影片開始',
  },
  {
    column: 'video_link',
    label: 'YT精華片段',
    updatable: String,
  },
  {
    column: 'batter.name',
    label: '打者',
    updatable: 'Batter',
  },
  {
    column: 'pitcher.name',
    label: '投手',
    updatable: 'Pitcher',
  },
  {
    column: 'catcher.name',
    label: '捕手',
    updatable: 'Catcher',
  },
  {
    column: 'PA_round',
    label: '第幾輪',
  },
  {
    column: 'PA_order',
    label: '打序',
  },
  {
    column: 'pinch',
    label: '代打',
  },
  {
    column: 'p_hand',
    label: '投球手',
    updatable: 'Handed',
  },
  {
    column: 'b_hand',
    label: '打擊手',
    updatable: 'Handed',
  },
  {
    column: 'strikes',
    label: '好球',
  },
  {
    column: 'balls',
    label: '壞球',
  },
  {
    column: 'ball_counts',
    label: '逐球',
  },
  {
    column: 'result',
    label: '打席結果',
    updatable: String,
  },
  {
    column: 'RBI',
    label: '打點',
    updatable: Number,
  },
  {
    column: 'location_code',
    label: '落點',
    updatable: String,
  },
  {
    column: 'location_coord_x',
    label: '落點x',
  },
  {
    column: 'location_coord_y',
    label: '落點y',
  },
  {
    column: 'trajectory',
    label: '彈道',
    updatable: String,
  },
  {
    column: 'start_away_score',
    label: '開始客場分',
    updatable: Number,
  },
  {
    column: 'start_home_score',
    label: '開始主場分',
    updatable: Number,
  },
  {
    column: 'away_score',
    label: '客場分',
    updatable: Number,
  },
  {
    column: 'home_score',
    label: '主場分',
    updatable: Number,
  },
  {
    column: 'end_away_score',
    label: '結束客場分',
    updatable: Number,
  },
  {
    column: 'end_home_score',
    label: '結束主場分',
    updatable: Number,
  },
  {
    column: 'start_outs',
    label: '開始出局數',
    updatable: Number,
  },
  {
    column: 'outs',
    label: '出局數',
    updatable: Number,
  },
  {
    column: 'end_outs',
    label: '結束出局數',
    updatable: Number,
  },
  {
    column: 'start_bases',
    label: '開始壘包狀態',
    updatable: Number,
  },
  {
    column: 'bases',
    label: '壘包狀態',
    updatable: Number,
  },
  {
    column: 'end_bases',
    label: '結束壘包狀態',
    updatable: Number,
  },
  {
    column: 'hardness',
    label: '擊球強度',
  },
  {
    column: 'LI',
    label: 'LI',
  },
  {
    column: 'RE',
    label: 'RE',
  },
  {
    column: 'home_WE',
    label: '主場勝率',
  },
  {
    column: 'WPA',
    label: 'WPA',
  },
  {
    column: 'RE24',
    label: 'RE24',
  },
  {
    column: 'SP_game_score',
    label: '先發GameScore',
  },
  {
    column: 'fielders.1',
    label: '守位投',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.2',
    label: '守位捕',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.3',
    label: '守位一',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.4',
    label: '守位二',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.5',
    label: '守位三',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.6',
    label: '守位遊',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.7',
    label: '守位左',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.8',
    label: '守位中',
    updatable: 'Fielders',
  },
  {
    column: 'fielders.9',
    label: '守位右',
    updatable: 'Fielders',
  },
];

export const addSeqList = (PAList) => {
  return PAList.map((PA, PAIndex) => ({
    PASeq: PAIndex + 1,
    ...PA,
  }));
};

const FormalGamePAList = ({ players, opponentPlayers, PAList, handleUpdate, handleRowSave }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');
  const { statsUpdateRows } = useFormalGameState();
  const formalGameDispatch = useFormalGameDispatch();

  return (
    <div>
      {Object.keys(statsUpdateRows).length > 0 && (
        <section className="update-pending-list">
          <p>
            待更新清單
            <Button mini color="red" width="auto" onClick={() => handleUpdate()}>
              確認更新
            </Button>
          </p>
          <ul>
            {Object.keys(statsUpdateRows).map((rowIndex) =>
              statsUpdateRows[rowIndex].map((toUpdate, columnIndex) => (
                <li
                  key={`${PAList[rowIndex].inning}-${PAList[rowIndex].side}-${PAList[rowIndex].PA_order}-${PAList[rowIndex].PA_round}`}
                >
                  <p>
                    <Button
                      className="cancel-update"
                      mini
                      color="blue"
                      onClick={() =>
                        formalGameDispatch({ type: 'REMOVE_STATS_UPDATE_ROW', payload: { rowIndex, columnIndex } })
                      }
                    >
                      x
                    </Button>
                    {`${PAList[rowIndex].inning}局 ${PAList[rowIndex].PA_order}棒 ${PAList[rowIndex].batter.name}: `}
                    {`${toUpdate.toUpdateColumn} -> ${JSON.stringify(toUpdate.newValue)}`}
                  </p>
                </li>
              )),
            )}
          </ul>
        </section>
      )}
      {getUpdateDiv(
        addSeqList(PAList),
        columns,
        setSelectedRow,
        setSelectColumn,
        selectedRow,
        selectColumn,
        Object.keys(statsUpdateRows).length === 0 ? handleUpdate : null,
        {
          batters: players,
          pitchers: opponentPlayers,
          catchers: opponentPlayers,
          fielders: opponentPlayers,
          handleRowSave,
        },
      )}
      <StyledTableWrapper>
        {tableRender(
          addSeqList(PAList),
          columns,
          setSelectedRow,
          setSelectColumn,
          selectedRow,
          selectColumn,
          statsUpdateRows,
        )}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGamePAList;
